<ng-container *transloco="let t">
  @if (isNativeMobile()) {
    @if (nativeVariant() === 'dashboard') {
      <header
        id="native-header-dashboard"
        class="bg-black flex items-center justify-between relative z-10"
        role="banner"
      >
        @if (welcomeNameReady()) {
          <span id="native-welcome-text" class="font-dm text-lg font-semibold text-white truncate">
            {{ t('dashboardWelcomeBack', { name: welcomeName() || userName() }) }}
          </span>
        } @else {
          <div
            id="native-welcome-skeleton"
            class="h-6 w-40 rounded animate-shimmer"
            role="status"
            [attr.aria-label]="t('commonMessagesLoading')"
          ></div>
        }
        <button
          type="button"
          class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer shrink-0"
          [attr.aria-label]="t('commonAriaProfile')"
          (click)="onOpenProfile()"
        >
          <ld-svg-icon [src]="userCircleIcon" class="size-6 [--stroke-0:white]" aria-hidden="true" />
        </button>
      </header>
    } @else {
      <header id="native-header-loan" class="bg-black flex items-center relative z-10" role="banner">
        <div id="native-header-left" class="w-20 flex items-center shrink-0">
          <button
            type="button"
            class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
            [attr.aria-label]="t('commonAriaGoBack')"
            (click)="onBackClick()"
          >
            <ld-svg-icon [src]="chevronLeftIcon" class="size-6 [--stroke-0:white]" aria-hidden="true" />
          </button>
        </div>

        <div class="flex-1 flex flex-col items-center min-w-0 px-2">
          <span class="font-dm text-sm font-semibold text-white leading-5">
            {{ headerTitle() || t('globalHeaderLoanLabel', { last4: loanLast4() }) }}
          </span>
          @if (headerSubtitle() || loanAddress()) {
            <span class="font-dm text-xs text-white/70 leading-4 truncate max-w-full">
              {{ headerSubtitle() || loanAddress() }}
            </span>
          }
        </div>

        @if (showHeaderActions()) {
          <div id="native-header-right" class="w-20 flex items-center justify-end shrink-0">
            <button
              id="native-help-btn"
              type="button"
              class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
              [attr.aria-label]="t('commonHelp')"
              (click)="onOpenHelp()"
            >
              <ld-svg-icon [src]="helpIcon" class="size-5 [--stroke-0:white]" aria-hidden="true" />
            </button>
            @if (showMessages()) {
              <button
                id="native-messages-btn"
                type="button"
                class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
                [attr.aria-label]="t('commonMessages')"
                (click)="onMessagesButtonClick()"
              >
                <ld-svg-icon [src]="envelopeIcon" class="size-5 [--stroke-0:white]" aria-hidden="true" />
              </button>
            }
          </div>
        } @else {
          <div class="w-20 shrink-0"></div>
        }
      </header>
    }
  } @else if (isMobile()) {
    <header
      id="global-header-mobile"
      class="bg-white shadow-card flex items-center gap-4 relative z-10 h-16 w-full"
      role="banner"
    >
      <div id="mobile-header-left" class="flex flex-1 items-center gap-2">
        @if (isJvTheme()) {
          @if (mlaConfigService.homePageUrl()) {
            <button
              id="mobile-header-logo-container"
              type="button"
              class="h-8 flex items-center bg-transparent border-none cursor-pointer p-0"
              (click)="onLogoClick()"
            >
              <img
                id="mobile-header-logo"
                [src]="logo()"
                [alt]="partnerDisplayName()"
                class="h-8 w-38 object-contain"
                width="152"
                height="32"
              />
            </button>
          } @else {
            <div id="mobile-header-logo-container" class="h-8 flex items-center">
              <img
                id="mobile-header-logo"
                [src]="logo()"
                [alt]="partnerDisplayName()"
                class="h-8 w-38 object-contain"
                width="152"
                height="32"
              />
            </div>
          }
        } @else {
          <a id="mobile-header-logo-link" routerLink="/" [attr.aria-label]="t('commonAriaLoanDepotHome')">
            <img
              id="mobile-header-logo"
              [src]="logo()"
              [alt]="partnerDisplayName()"
              class="h-8 w-38 object-contain"
              width="152"
              height="32"
            />
          </a>
        }
      </div>

      <div id="mobile-header-right" class="flex items-center shrink-0">
        @if (showContactSupport()) {
          <a
            id="mobile-header-phone"
            [href]="contactSupportTel"
            class="flex items-center justify-center size-10 p-0 rounded-full focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
            [attr.aria-label]="t('globalHeaderContactSupport', { phone: contactSupportPhone })"
          >
            <ld-svg-icon
              [src]="phoneIcon"
              class="size-6 shrink-0"
              style="--stroke-0: var(--color-ld-neutral)"
              aria-hidden="true"
            />
          </a>
        }
        @if (showProfile()) {
          <button
            id="mobile-header-profile-button"
            type="button"
            class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
            [attr.aria-label]="t('commonAriaProfile')"
            (click)="onOpenProfile()"
          >
            <ld-svg-icon
              [src]="userCircleIcon"
              class="size-6 [--stroke-0:var(--color-ld-neutral)]"
              aria-hidden="true"
            />
          </button>
        }
      </div>
    </header>

    @if (nativeVariant() !== 'dashboard') {
      <div id="mobile-web-loan-sub-header" class="bg-black flex items-center relative z-10 h-12 w-full">
        <div id="mobile-sub-header-left" class="w-20 flex items-center shrink-0">
          @if (showBackButton()) {
            <button
              type="button"
              class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
              [attr.aria-label]="t('commonAriaGoBack')"
              (click)="onBackClick()"
            >
              <ld-svg-icon [src]="chevronLeftIcon" class="size-6 [--stroke-0:white]" aria-hidden="true" />
            </button>
          }
        </div>

        <div class="flex-1 flex flex-col items-center min-w-0 px-2">
          <span class="font-dm text-sm font-semibold text-white leading-5">
            {{ headerTitle() || t('globalHeaderLoanLabel', { last4: loanLast4() }) }}
          </span>
          @if (headerSubtitle() || loanAddress()) {
            <span class="font-dm text-xs text-white/70 leading-4 truncate max-w-full">
              {{ headerSubtitle() || loanAddress() }}
            </span>
          }
        </div>

        @if (showHeaderActions()) {
          <div id="mobile-sub-header-right" class="w-20 flex items-center justify-end shrink-0">
            <button
              id="mobile-sub-header-help-btn"
              type="button"
              class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
              [attr.aria-label]="t('commonHelp')"
              (click)="onOpenHelp()"
            >
              <ld-svg-icon [src]="helpIcon" class="size-5 [--stroke-0:white]" aria-hidden="true" />
            </button>
            @if (showMessages()) {
              <button
                id="mobile-sub-header-messages-btn"
                type="button"
                class="flex items-center justify-center size-10 rounded-full bg-transparent border-none cursor-pointer"
                [attr.aria-label]="t('commonMessages')"
                (click)="onMessagesButtonClick()"
              >
                <ld-svg-icon [src]="envelopeIcon" class="size-5 [--stroke-0:white]" aria-hidden="true" />
              </button>
            }
          </div>
        } @else {
          <div id="mobile-sub-header-right" class="w-20 shrink-0"></div>
        }
      </div>
    }
  } @else {
    <header id="global-header" class="bg-white w-full flex flex-col relative z-10 shadow-card">
      <div id="global-top-bar" class="w-full h-[64px] flex items-center justify-center border-b border-ld-border">
        <div class="max-w-[1440px] w-full h-full flex items-center gap-10 px-8 max-lg:gap-6">
          <div id="global-logo-section" class="w-[184px] h-10 flex items-center shrink-0 max-sm:w-[140px]">
            @if (isJvTheme()) {
              @if (mlaConfigService.homePageUrl()) {
                <button
                  id="global-logo-container"
                  type="button"
                  class="w-full h-full flex items-center bg-transparent border-none cursor-pointer p-0"
                  (click)="onLogoClick()"
                >
                  <img
                    id="global-logo-img"
                    [src]="logo()"
                    [alt]="partnerDisplayName()"
                    class="w-full h-full object-contain object-left"
                  />
                </button>
              } @else {
                <div id="global-logo-container" class="w-full h-full flex items-center">
                  <img
                    id="global-logo-img"
                    [src]="logo()"
                    [alt]="partnerDisplayName()"
                    class="w-full h-full object-contain object-left"
                  />
                </div>
              }
            } @else {
              <a id="global-logo-link" routerLink="/dashboard" class="w-full h-full flex items-center">
                <img
                  id="global-logo-img"
                  [src]="logo()"
                  [alt]="partnerDisplayName()"
                  class="w-full h-full object-contain object-left"
                />
              </a>
            }
          </div>

          <div id="global-top-actions" class="flex gap-6 ml-auto items-center max-sm:gap-3">
            @if (showContactSupport()) {
              <a
                id="global-header-phone"
                [href]="contactSupportTel"
                class="flex items-center gap-2 no-underline transition-opacity duration-200 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
                [attr.aria-label]="t('globalHeaderContactSupport', { phone: contactSupportPhone })"
              >
                <ld-svg-icon
                  id="global-header-phone-icon"
                  [src]="phoneIcon"
                  class="size-6 shrink-0"
                  style="--stroke-0: var(--color-ld-neutral)"
                  aria-hidden="true"
                />
                <span
                  id="global-header-contact-label"
                  class="font-dm text-base leading-6 tracking-[0.04px] font-normal text-ld-neutral-700"
                >
                  {{ t('globalHeaderContactSupportLabel') }}
                </span>
                <span
                  id="global-header-phone-number"
                  class="font-dm text-base leading-6 tracking-[0.04px] font-semibold text-ld-primary"
                >
                  {{ contactSupportPhone }}
                </span>
              </a>
            }
            @if (showProfile()) {
              <button
                id="user-profile-btn"
                class="flex items-center gap-2 py-1 px-0 bg-transparent border-none text-ld-neutral-700 font-dm text-base font-normal cursor-pointer transition-opacity duration-200 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
                [matMenuTriggerFor]="userMenu"
              >
                <ld-svg-icon
                  id="user-profile-icon"
                  class="w-6 h-6 flex items-center justify-center shrink-0"
                  [src]="userIconDark"
                  alt=""
                />
                @if (welcomeNameReady()) {
                  <span id="user-profile-label" class="whitespace-nowrap">{{ userName() }}</span>
                } @else {
                  <span
                    id="user-profile-label-skeleton"
                    class="inline-block h-4 w-24 rounded animate-shimmer"
                    role="status"
                    [attr.aria-label]="t('commonMessagesLoading')"
                  ></span>
                }
                <ld-svg-icon
                  id="user-profile-chevron"
                  [src]="chevronDownIcon"
                  class="size-5"
                  style="--stroke-0: var(--color-ld-neutral)"
                  aria-hidden="true"
                />
              </button>
              <mat-menu #userMenu="matMenu" id="user-menu" class="profile-dropdown-menu">
                @if (showBorrowerSelector()) {
                  <div id="menu-section-profiles" class="profile-menu-section-header">
                    {{ t('profileMenuSwitchProfile') }}
                  </div>
                  @for (borrower of borrowerOptions(); track borrower.id) {
                    <button
                      mat-menu-item
                      [id]="'menu-borrower-' + borrower.id"
                      class="profile-menu-item"
                      [disabled]="currentBorrower()?.id === borrower.id"
                      (click)="onBorrowerClick(borrower)"
                    >
                      @if (currentBorrower()?.id === borrower.id) {
                        <ld-svg-icon
                          [src]="checkCircleIcon"
                          class="size-4 shrink-0"
                          style="--stroke-0: var(--color-ld-primary)"
                          aria-hidden="true"
                        />
                      } @else {
                        <ld-svg-icon
                          [src]="userCircleIcon"
                          class="size-4 shrink-0"
                          style="--stroke-0: var(--color-ld-neutral-500)"
                          aria-hidden="true"
                        />
                      }
                      <span
                        class="font-dm text-base leading-6 tracking-[0.04px] font-medium"
                        [class.text-ld-primary]="currentBorrower()?.id === borrower.id"
                        [class.text-ld-neutral-700]="currentBorrower()?.id !== borrower.id"
                      >
                        {{ borrower.displayName }}
                      </span>
                    </button>
                  }
                  <mat-divider></mat-divider>
                }

                @if (showMfaPreferences()) {
                  <button
                    mat-menu-item
                    id="menu-update-mfa"
                    class="profile-menu-item"
                    (click)="onUpdateMfaPreferences()"
                  >
                    <ld-svg-icon
                      [src]="phoneIcon"
                      class="size-4 shrink-0"
                      style="--stroke-0: var(--color-ld-neutral)"
                      aria-hidden="true"
                    />
                    <span class="font-dm text-base leading-6 tracking-[0.04px] font-medium text-ld-neutral-700">
                      {{ t('profileMenuUpdateMfaPreferences') }}
                    </span>
                  </button>
                }

                @if (showTourOption()) {
                  <button mat-menu-item id="menu-take-tour" class="profile-menu-item" (click)="onTakeTour()">
                    <ld-svg-icon
                      [src]="tourIcon"
                      class="size-4 shrink-0"
                      style="--stroke-0: var(--color-ld-neutral)"
                      aria-hidden="true"
                    />
                    <span class="font-dm text-base leading-6 tracking-[0.04px] font-medium text-ld-neutral-700">
                      {{ t('tourMenuTakeATour') }}
                    </span>
                  </button>
                }

                @if (isNativeMobile()) {
                  <button mat-menu-item id="menu-feedback" class="profile-menu-item" routerLink="/feedback">
                    <ld-svg-icon
                      [src]="feedbackIcon"
                      class="size-4 shrink-0"
                      style="--stroke-0: var(--color-ld-neutral)"
                      aria-hidden="true"
                    />
                    <span class="font-dm text-base leading-6 tracking-[0.04px] font-medium text-ld-neutral-700">
                      {{ t('feedbackMenuLink') }}
                    </span>
                  </button>
                }

                <button
                  mat-menu-item
                  id="menu-logout"
                  class="profile-menu-item profile-menu-item--logout"
                  (click)="onLogout()"
                >
                  <ld-svg-icon id="menu-logout-icon" class="w-4 h-4 shrink-0" [src]="logoutIcon" aria-hidden="true" />
                  <span
                    id="menu-logout-label"
                    class="font-dm text-base leading-6 tracking-[0.04px] font-semibold text-ld-error"
                  >
                    {{ t('commonSignOut') }}
                  </span>
                </button>
              </mat-menu>
            }
          </div>
        </div>
      </div>
    </header>
  }

  <ld-mfa-preferences-modal [isOpen]="showMfaPreferencesModal()" (closeModal)="onMfaPreferencesModalClose()" />
</ng-container>
